import type { MatchStatus } from "./matchStatus";

const statusPriority: Record<MatchStatus, number> = { live: 0, upcoming: 1, finished: 2 };

export function orderMatchesForDisplay<T extends { status: MatchStatus; matchDate: Date | string }>(matches: T[]) {
  return [...matches].sort((a, b) => {
    const statusDifference = statusPriority[a.status] - statusPriority[b.status];
    if (statusDifference !== 0) return statusDifference;
    return new Date(a.matchDate).getTime() - new Date(b.matchDate).getTime();
  });
}
